import React, { useState, useEffect } from "react";
import experienceDetailBG from "../../../assets/images/others/host-side-images/experienceDetailBG.png";
import { ReactComponent as EditBtn } from "../../../assets/images/svgs/edit-btn-svg.svg";
import { ReactComponent as LocationIcon } from "../../../assets/images/svgs/locationDark.svg";
import { ReactComponent as CalandarIcon } from "../../../assets/images/svgs/calendarDark.svg";
import { ReactComponent as ClockIcon } from "../../../assets/images/svgs/clockdark.svg";
import { ReactComponent as InforCircle } from "../../../assets/images/svgs/info-circle.svg";
import attende1 from "../../../assets/images/others/host-side-images/attende1.png";
import attende2 from "../../../assets/images/others/host-side-images/attende2.png";
import attende3 from "../../../assets/images/others/host-side-images/attende3.png";
import attende4 from "../../../assets/images/others/host-side-images/attende4.png";
import hostImage from "../../../assets/images/others/host-side-images/hostImg.png";
import eventBadge from "../../../assets/images/others/host-side-images/eventBadge.png";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "../../../utils/helpers/enums/routes";
import AttendeeBreadcrumb, {
  AttendeBreadcrumbLink,
} from "../../../components/breadcrumbs/AttendeeBreadcrumb";
import { IoInformationCircle } from "react-icons/io5";
import useStore from "hooks/useStore";

const SignedUpExperience = () => {
  const [isSkillLevelTooltipVisible, setIsSkillLevelTooltipVisible] =
    useState(false);
  const breadcrumbLinks: AttendeBreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.attendeeHome },
    { title: "Experiences Detail", path: siteRoutes.experiencesDetailAttendee },
  ];

  const navigate = useNavigate();
  const { isProfileCompleted } = useStore();

  // Check profile completion on mount - redirect to home if not completed
  useEffect(() => {
    const profileCompleted = isProfileCompleted();
    if (!profileCompleted) {
      navigate(siteRoutes.attendeeHome, { replace: true });
    }
  }, [isProfileCompleted, navigate]);
  return (
    <div>
      <div
        style={{ backgroundImage: `url(${experienceDetailBG})` }}
        className="bg-cover bg-center bg-no-repeat h-full md:h-[500px] w-full"
      >
        <div className="h-full host-bg-gradient">
          <div className="container">
            <div className="flex flex-wrap justify-between gap-6 items-center">
              <AttendeeBreadcrumb links={breadcrumbLinks} />
            </div>
            <div className="flex items-end mt-4 md:mt-14">
              <div className="flex flex-col gap-4">
                <p className="flex items-center text-base text-lightBlackText">
                  <LocationIcon className="mr-1" /> ABC Avenue, San Francisco
                </p>
                <h1 className="text-blackie text-2xl md:3xl lg:text-5xl font-medium ">
                  How to improve your <br /> Communication and Social Life
                </h1>
                <div className="flex flex-wrap gap-4 text-base text-lightBlackText">
                  <p className="flex items-center gap-1">
                    <CalandarIcon /> 14 October, 2024
                  </p>
                  <p className="flex items-center gap-1">
                    <ClockIcon /> 12:30 to 02:30
                  </p>
                </div>
                <div className="flex flex-wrap gap-6 items-center">
                  <div
                    className="flex items-center cursor-pointer"
                    onClick={() => {
                      navigate(siteRoutes.attendess);
                    }}
                  >
                    {[attende1, attende2, attende3, attende4].map(
                      (attende, index) => (
                        <img
                          key={index}
                          className={`w-[30px] h-[30px] object-cover object-center rounded-full border border-white ${
                            index > 0 ? "ml-[-8px]" : ""
                          }`}
                          src={attende}
                          alt={`Attendee ${index + 1}`}
                        />
                      )
                    )}
                    <span className="text-base text-lightBlackText ml-2">
                      15+ attending
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-5 items-center">
                    <button className="bg-yellowText rounded-md text-white px-4 py-2">
                      Workshop
                    </button>
                    <span className="text-2xl text-blackie font-semibold">
                      $120
                    </span>
                    <span className="text-xl text-lightBlackText">
                      0 Slots Available
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-6">
        <div className="flex  justify-center mt-4 md:justify-end md:mt-[-120px] lg:mt-[-200px]">
          <div className="flex flex-wrap gap-4 ">
            <div className="flex flex-col items-center justify-center gap-2 rounded-lg bg-white p-4 shadow-md">
              <img
                className="w-[196px] h-[170px]"
                src={eventBadge}
                alt="Event Badge"
              />
              <span className="text-base font-medium">Event Badge</span>
            </div>

            <div className="flex flex-col items-center justify-center gap-2 rounded-lg bg-white p-4 shadow-md">
              <img
                className="w-[196px] h-[170px] rounded-full object-contain"
                src={hostImage}
                alt="Host"
              />
              <div className="text-center">
                <p className="font-medium text-lg">Host</p>
                <p className="font-semibold text-base">Steve Johnson</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap sm:flex-nowrap justify-between items-center gap-6 mt-6 sm:mt-16">
          <div className="text-blackie text-3xl">Overview</div>
        </div>
        <div className="w-full md:w-[60%] my-5">
          <div>
            <h3 className="text-blackie text-xl font-medium mb-2">
              About Experience
            </h3>
            <p className="text-lightBlackText text-base">
              Ultricies arcu venenatis in lorem faucibus lobortis at. East odio
              varius nisl congue aliquam nunc est sit pull convallis magna. Est
              scelerisque dignissim non non nibh....
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 my-6">
            <div>
              <h3 className="text-blackie text-xl font-medium mb-2">
                Age Group
              </h3>
              <p className="text-lightBlackText text-base">
                Primary School (Grade 4-6) Ages 9-12
              </p>
            </div>
            <div>
              <div className="mb-4">
                <h3 className="text-blackie text-xl font-medium mb-2">
                  Language
                </h3>
                <div className="flex gap-2">
                  <span className="px-3 py-1 bg-fade text-blackie rounded-lg text-base">
                    English
                  </span>
                  <span className="px-3 py-1 bg-fade text-blackie rounded-lg text-base">
                    Spanish
                  </span>
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-blackie text-xl font-medium mb-2">
                Skill Level
              </h3>
              <p className="text-lightBlackText text-base">
                Appropriate for Age
              </p>
            </div>
          </div>
          <div>
            <h2 className="text-2xl font-medium text-blackie mb-2">Details</h2>

            <div>
              <h3 className="text-blackie text-xl font-medium mb-2">
                Learning Activity
              </h3>
              <p className="text-lightBlackText text-base">
                Ultricies arcu venenatis in lorem faucibus lobortis at. East
                odio varius nisl congue aliquam nunc est sit pulvinar.
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 my-6">
              <div>
                <h3 className="text-blackie text-xl font-medium mb-2">
                  Core Concepts
                </h3>
                <p className="text-lightBlackText text-base">
                  Leadership, Negotiation, Presentation
                </p>
              </div>

              <div className="relative">
                <h3 className="text-blackie text-xl font-medium mb-2 flex items-center gap-1">
                  Skill Level
                  <span
                    className="cursor-pointer text-gray-500 hover:text-gray-700 relative flex"
                    onMouseEnter={() => setIsSkillLevelTooltipVisible(true)}
                    onMouseLeave={() => setIsSkillLevelTooltipVisible(false)}
                  >
                    <InforCircle />
                  </span>
                </h3>
                {/* Tooltip */}
                {isSkillLevelTooltipVisible && (
                  <div className="absolute w-[400px] bottom-18 left-20 p-4 rounded-t-lg rounded-br-lg bg-primaryBlueBg text-white text-xs opacity-100 transition-opacity duration-300 z-10">
                    <div className="flex flex-col gap-1">
                      <h2 className="font-medium text-sm ">Age Level</h2>
                      <p className="text-xs">
                        This experience is designed with activities and
                        challenges that match typical skill levels and
                        development stages for a specific age range. The
                        content, pace, and materials are age-appropriate to help
                        learners succeed and feel confident.
                      </p>
                      <h2 className="font-medium text-sm mt-2">
                        Exceptional Learner
                      </h2>
                      <p className="text-xs">
                        This experience is tailored to support exceptional
                        learners who may benefit from specific accommodations or
                        adjustments, such as sensory adaptations, extra
                        assistance, or a more flexible approach. The environment
                        and materials are selected to help create an engaging,
                        supportive setting for diverse learning needs.
                      </p>
                      <h2 className="font-medium text-sm mt-2">Both</h2>
                      <p className="text-xs">
                        This experience welcomes all age groups & skill levels.
                        While every effort will be made to adapt to the needs of
                        a diverse group, parents or guardians should assess
                        whether the experience aligns with their child's
                        learning preferences & needs.
                      </p>
                    </div>
                  </div>
                )}
                <p className="text-lightBlackText text-base">
                  Physical Conservation
                </p>
              </div>

              <div>
                <h3 className="text-blackie text-xl font-medium mb-2">
                  Special Instructions
                </h3>
                <p className="text-lightBlackText text-base">
                  Parking, Checking in
                </p>
              </div>
              <div>
                <h3 className="text-blackie text-xl font-medium mb-2">
                  Physical Consideration
                </h3>
                <ul className="text-lightBlackText text-base list-disc list-inside">
                  <li>Requires lots of walking or standing</li>
                  <li>Not handicap accessible</li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-blackie mb-6">
              Mission
            </h2>
            <div>
              <h3 className="text-blackie text-xl font-medium mb-2">Mission</h3>
              <p className="text-lightBlackText text-base">
                Ultricies arcu venenatis in lorem faucibus lobortis at. East
                odio varius nisl congue aliquam nunc est sit pull convallis
                magna. Est scelerisque dignissim non non nibh....
              </p>
            </div>
            <div>
              <h3 className="text-blackie text-xl font-medium mb-2 mt-3">
                About{" "}
              </h3>
              <p className="text-lightBlackText text-base">
                Ultricies arcu venenatis in lorem faucibus lobortis at. East
                odio varius nisl congue aliquam nunc est sit pull convallis
                magna. Est scelerisque dignissim non non nibh....
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 my-6">
              <div className="">
                <p className="text-blackie  font-medium text-xl">
                  Business Name
                </p>
                <p className="text-lightBlackText text-base">
                  Alpha Enterprises
                </p>
              </div>
              <div className="">
                <p className="text-blackie text-xl font-medium ">
                  Business Website
                </p>
                <a
                  href="https://www.alphaenterprises.pk"
                  className="text-blue-600 text-base"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.alphaenterprises.pk
                </a>
              </div>
            </div>
            <div className="flex flex-wrap gap-4">
              <button onClick={()=>{navigate(siteRoutes.attendeeJoining)}} className="bg-labelTextColor text-white  py-3 rounded-full w-[170px] text-center">
                Join
              </button>
              <button className="bg-lightGray text-primaryBlueText  py-3 rounded-full w-[170px] text-center">
                Add me to Waitlist
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignedUpExperience;
